module.exports = __webpack_public_path__ + "static/media/maelstrom.f288bbaf.jpg";